import { useStaticQuery, graphql } from 'gatsby'

export const useOurStoryQuery = () => {
  const { wpPage, wp } = useStaticQuery(graphql`
    query OurStoryQuery {
      wpPage(title: { eq: "Home" }) {
        ourStory {
          ourStory {
            title
            subtitle
            text
            largerText
            link {
              title
              url
            }
            teamBackgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, quality: 100)
                }
              }
            }
            yearsInBusinessImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            yearsInBusinessAltText
            truckImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            truckAltText
          }
        }
      }
      wp {
        acfOptionsCommonItems {
          commonItems {
            playButton {
              playButton {
                localFile {
                  publicURL
                }
              }
              videoLink {
                title
                url
              }
            }
          }
        }
      }
    }
  `)
  return { wpPage, wp }
}
